import React from 'react';
import { getInstitutionLogoSources } from '../utils/institutionLogo';

interface InstitutionLogoProps {
  institution: string;
  plaidLogoUrl?: string;
  size?: number; // px, default 36
}

const InstitutionLogo: React.FC<InstitutionLogoProps> = ({ institution, plaidLogoUrl, size = 36 }) => {
  const sources = React.useMemo(
    () => getInstitutionLogoSources(institution, plaidLogoUrl),
    [institution, plaidLogoUrl]
  );
  const [idx, setIdx] = React.useState(0);

  const dim = `${size}px`;

  if (idx < sources.length) {
    return (
      <img
        key={sources[idx]}
        src={sources[idx]}
        alt={institution}
        style={{ width: dim, height: dim }}
        className="rounded-lg object-contain bg-white p-0.5 flex-shrink-0"
        onError={() => setIdx(i => i + 1)}
      />
    );
  }

  return (
    <div
      style={{ width: dim, height: dim, backgroundColor: 'var(--primary-color)' }}
      className="rounded-lg flex items-center justify-center flex-shrink-0 text-white font-bold"
    >
      {institution.charAt(0).toUpperCase()}
    </div>
  );
};

export default InstitutionLogo;
